import { Sheet } from "./ui/Sheet";
import { Icon } from "./Icon";

const BOOK_ADD_LABEL = "افزودن کتاب";
const MEDIA_ADD_LABEL = "افزودن فیلم یا سریال";
const FINANCE_ADD_LABEL = "ثبت تراکنش مالی";

const QUICK_ADD_ROWS = [
  BOOK_ADD_LABEL,
  MEDIA_ADD_LABEL,
  "افزودن مکان",
  "افزودن پروژه",
  FINANCE_ADD_LABEL,
  "افزودن مورد به لیست خرید",
];

interface QuickAddSheetProps {
  open: boolean;
  onClose: () => void;
  onSelect: (label: string) => void;
  /** When set, invoked instead of onSelect for the book row, which has a real create flow. */
  onBookAdd?: () => void;
  /** When set, invoked instead of onSelect for the movie/series row, which has a real TMDB-backed create flow. */
  onMediaAdd?: () => void;
  /** When set, invoked instead of onSelect for the finance transaction row, which has a real create flow. */
  onFinanceAdd?: () => void;
}

/**
 * The FAB's "افزودن سریع" sheet. Places only support edit, status,
 * notes/logs, and delete on existing rows (no create endpoint), and
 * projects/shopping have no write routes at all, so those rows report a
 * truthful "not available yet" toast via onSelect. Books, movies/series, and
 * finance transactions do have a real create endpoint, so those rows route
 * through onBookAdd/onMediaAdd/onFinanceAdd instead.
 */
export function QuickAddSheet({ open, onClose, onSelect, onBookAdd, onMediaAdd, onFinanceAdd }: QuickAddSheetProps) {
  return (
    <Sheet open={open} onClose={onClose} title="افزودن سریع">
      <div className="quick-add-list">
        {QUICK_ADD_ROWS.map((label) => (
          <button
            key={label}
            type="button"
            className="quick-add-row"
            onClick={() => {
              onClose();
              if (label === BOOK_ADD_LABEL && onBookAdd) {
                onBookAdd();
              } else if (label === MEDIA_ADD_LABEL && onMediaAdd) {
                onMediaAdd();
              } else if (label === FINANCE_ADD_LABEL && onFinanceAdd) {
                onFinanceAdd();
              } else {
                onSelect(label);
              }
            }}
          >
            <span className="quick-add-row__label">{label}</span>
            <Icon name="chevron-left" width={14} height={14} aria-hidden="true" />
          </button>
        ))}
      </div>
    </Sheet>
  );
}
